import { JSX } from 'react';
import { ContentContainer, Text } from '@ahc-digital/component-library';
import { Text as JSSText } from '@sitecore-jss/sitecore-jss-nextjs';
import Script from 'next/script';
import { useCustomSitecoreContext } from 'src/shared/useCustomSitecoreContext';
import { SwitchToPreviewMessage } from 'src/shared/SwitchToPreviewMessage';
import { I21OdezaChatProps } from './I21OdezaChat.types';
import { getKvpValue } from 'src/shared/field-utils';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';

const sourceUrls: Record<string, string> = {
  Atrium: 'https://atriumchat.odeza.com/chat-loader.min.js',
  Navicent: 'https://cdn.odeza.com/navicent/widget/js/chat-loader.min.js',
  'Floyd Harbin': 'https://cdn.odeza.com/floyd/widget/js/chat-loader.js',
};

const Default = (props: I21OdezaChatProps): JSX.Element => {
  const context = useCustomSitecoreContext();
  const isEditing = context?.pageEditing ?? false;

  const { APIKey, OdezaSource } = props?.fields ?? {};

  const key = APIKey?.value?.trim();
  const scriptSource = getKvpValue(OdezaSource);

  if (isEditing) {
    return (
      <SwitchToPreviewMessage componentName={props?.rendering?.componentName}>
        <ContentContainer>
          <Text tag="p" fontStyle="smParagraphBold">
            API Key: <JSSText field={APIKey} />
          </Text>
          <br />
          <Text tag="p" fontStyle="smParagraphBold">
            Odeza Source: {scriptSource ? scriptSource : 'Not Selected'}
          </Text>
          <br />
        </ContentContainer>
      </SwitchToPreviewMessage>
    );
  }

  if (!key && !scriptSource) return <></>;

  const sourceUrl = scriptSource ? sourceUrls[scriptSource] : undefined;

  if (!sourceUrl) return <></>;

  return (
    <>
      <Script id="odeza-chat">
        {`
          const script = document.createElement('script');
          script.src = '${sourceUrl}';
          script.async = true;
          script.onload = () => {
            initiateChatbot({ apiKey: '${key}'});
            document.dispatchEvent(new Event("DOMContentLoaded", {
              bubbles: true,
              cancelable: true
            }));
          };;
          document.body.appendChild(script);
        `}
      </Script>
    </>
  );
};

export default checkDatasourceForRendering<I21OdezaChatProps>(Default);
